/**
 * 角色权限api
 * date:2022 04 21
 */
 import httpRequest from '@/utils/request.js';


   /**查询列表 */
   export const roleList = (params = {}) => httpRequest.httpGet({
    url: '/service/role/list', params: {
      ...params
    }
  })
   /**获取可操作性资源 */
   export const roleResource = (params = {}) => httpRequest.httpGet({
    url: '/service/role/resource', params: {
      ...params
    }
  })
   /**获取角色客户 */
   export const roleCustomer = (params = {}) => httpRequest.httpGet({
    url: '/service/role/customer', params: {
      ...params
    }
  })
   /**获取角色详细 */
   export const roleDetail = (params = {}) => httpRequest.httpGet({
    url: '/service/role/detail', params: {
      ...params
    }
  })
   /**根据角色ID获取关联用户 */
   export const roleUser = (params = {}) => httpRequest.httpGet({
    url: '/service/role/user', params: {
      ...params
    }
  })
   /**新增 */
   export const roleNew = (data) => httpRequest.httpPost('/service/role/new', data)
   /**编辑 */
   export const roleEdit = (data) => httpRequest.httpPut('/service/role/edit', data)
   /**删除 */
   export const roleRemove = (data) => httpRequest.httpdelete('/service/role/remove', data)
   /**激活 */
   export const roleActive = (data) => httpRequest.httpPut('/service/customer/active', data)
   /**注销 */
   export const roleCancel = (data) => httpRequest.httpPut('/service/customer/cancel', data)